module.exports = __webpack_public_path__ + "img/9788983783141.01cd7d34.jpg";